import { Table, Accordion } from "@mantine/core";
import React from "react";
import { getChargeStatus, getFormattedAmount } from "../../util";

const ChargesSection = ({ charges, isMobile }) => {
  const tableHeads = (
    <tr>
      <th>{isMobile ? "Dragning" : "Dragningsdatum"}</th>
      <th>Summa</th>
      <th>Status</th>
      <th>{isMobile ? "Betald" : "Betaldatum"}</th>
    </tr>
  );

  const rows = charges.map((charge) => {
    const date = charge.dueDate.split("T")[0];
    const status = getChargeStatus(charge.status);
    const formattedAmount = getFormattedAmount(charge.amount);

    return (
      <tr key={charge.dueDate}>
        <td>{date}</td>
        <td>{formattedAmount}</td>
        <td>{status}</td>
        <td>{charge.chargedAt}</td>
      </tr>
    );
  });

  return (
    <Accordion>
      <Accordion.Item value="paymentHistory">
        <Accordion.Control>Betalhistorik</Accordion.Control>
        <Accordion.Panel>
          <Table withBorder={!isMobile} striped>
            <thead>{tableHeads}</thead>
            <tbody>{rows}</tbody>
          </Table>
        </Accordion.Panel>
      </Accordion.Item>
    </Accordion>
  );
};

export default ChargesSection;
